import { render, staticRenderFns } from "./mysetup.vue?vue&type=template&id=66437ca7&scoped=true&"
import script from "./mysetup.vue?vue&type=script&lang=js&"
export * from "./mysetup.vue?vue&type=script&lang=js&"
import style0 from "./mysetup.vue?vue&type=style&index=0&id=66437ca7&lang=scss&scoped=true&"
import style1 from "./mysetup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66437ca7",
  null
  
)

export default component.exports